window._addMeToCart = function(e, el) {
  e.preventDefault();
  
  // Get the variant ID from the clicked element
  let variantId = el.getAttribute('data-variant_id');

  if (!variantId) {
    console.error('No variant ID found.');
    return;
  }

  // Prepare the form data to add the product to the cart
  let formData = {
    'items': [
      {
        'id': variantId,
        'quantity': 1
      }
    ]
  };

  // Fetch request to add the product to the cart
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    // Trigger the drawer to open by dispatching the 'cart:refresh' event
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));

    // Optionally, dispatch the 'product:added' event for further customization
    document.dispatchEvent(new CustomEvent('product:added', {
      bubbles: true,
      detail: {
        variant: data.items[0]
      }
    }));
  })
  .catch(err => console.error('Error:', err));
};

/* =========================================================================
   Product card image gallery — per-card navigation.
   Arrows shift through product.media images in place (no scrolling).
   Progress indicator segments highlight the current index. State persists
   until page reload (held on the DOM — no storage).
   ========================================================================= */
(function () {
  function isTouch() {
    return window.matchMedia && window.matchMedia('(hover: none)').matches;
  }

  function setupGallery(card) {
    if (card.dataset.galleryBound === '1') return;
    // A colorway swap calls __rebuildProductCardGallery, which clears
    // galleryBound and re-runs this against the SAME track element and window.
    // With no teardown every swap stacked another full set of listeners, so
    // after N swaps a single swipe ran the scroll handler N times. Abort the
    // previous generation before binding a new one.
    if (card.__galleryAbort) { try { card.__galleryAbort.abort(); } catch (e) {} }
    var _ac = ('AbortController' in window) ? new AbortController() : null;
    card.__galleryAbort = _ac;
    var sig = _ac ? _ac.signal : undefined;
    var media = card.querySelectorAll('.product-gallery__media.snap-center');
    if (media.length < 2) return;

    var figure = card.querySelector('.product-card__figure');
    if (!figure) return;

    var track = figure.querySelector('[data-gallery-track]');
    var prev = figure.querySelector('[data-gallery-prev]');
    var next = figure.querySelector('[data-gallery-next]');
    var segments = figure.querySelectorAll('.product-card__progress-seg');
    var total = media.length;
    var index = 0;

    // First interaction with the gallery → warm every image of every colorway
    // on this card (handled by card-swatches.js). Idempotent per card.
    function prime() {
      if (window.__preloadCardColorways) window.__preloadCardColorways(card);
    }

    function applyVisuals() {
      for (var i = 0; i < media.length; i++) {
        media[i].classList.toggle('active', i === index);
        // Play/pause videos based on visibility — browsers won't autoplay
        // off-screen videos in the scroll track.
        if (media[i].tagName === 'VIDEO') {
          if (i === index) {
            media[i].play().catch(function(){});
          } else {
            media[i].pause();
          }
        }
      }
      for (var j = 0; j < segments.length; j++) {
        segments[j].classList.toggle('is-active', j === index);
      }
      if (prev) prev.classList.toggle('is-available', index > 0);
      if (next) next.classList.toggle('is-available', index < total - 1);
    }

    function scrollToIndex(i, smooth) {
      if (!track) return;
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
    }

    function onScroll() {
      if (!track || track.clientWidth === 0) return;
      // Any swipe-scroll while the panel is open dismisses it
      if (card.classList.contains('is-sticky-open')) {
        card.classList.remove('is-sticky-open');
      }
      var newIndex = Math.round(track.scrollLeft / track.clientWidth);
      if (newIndex < 0) newIndex = 0;
      if (newIndex > total - 1) newIndex = total - 1;
      if (newIndex !== index) {
        index = newIndex;
        applyVisuals();
      }
    }

    if (track) {
      track.addEventListener('scroll', onScroll, { passive: true, signal: sig });
    }

    // Arrow clicks → scroll to prev/next index
    if (prev) {
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        prime();
        if (index > 0) scrollToIndex(index - 1, true);
      }, { signal: sig });
    }
    if (next) {
      next.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        prime();
        if (index < total - 1) scrollToIndex(index + 1, true);
      }, { signal: sig });
    }

    // Always kill native drag on the track and wrapping anchor so mouse events
    // aren't hijacked by the browser's drag-and-drop API — needed both when the
    // card has its own drag AND when the outer scroll-carousel owns the drag.
    if (track) {
      track.addEventListener('dragstart', function (ev) { ev.preventDefault(); }, { signal: sig });
      var _mediaLink = track.closest('.product-card__media');
      if (_mediaLink) {
        _mediaLink.addEventListener('dragstart', function (ev) { ev.preventDefault(); }, { signal: sig });
      }
    }

    // Desktop click-and-drag on the image (mouse-only; touch uses native scroll).
    // Native overflow-x scroll containers don't respond to mouse-drag by default,
    // so we simulate it: track mousedown on the track, translate mousemove deltas
    // into scrollLeft, and snap to the nearest item on release.
    if (track) {
      var dragging = false;
      var startX = 0;
      var startScroll = 0;
      var startIndex = 0;
      var moved = 0;
      var DRAG_THRESHOLD = 5;
      var COMMIT_RATIO = 0.05; // drag >5% of width to commit to next/prev

      track.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        prime();
        dragging = true;
        moved = 0;
        startX = e.pageX;
        startScroll = track.scrollLeft;
        startIndex = index;
        track.classList.add('is-grabbing');
      }, { signal: sig });

      window.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        var delta = e.pageX - startX;
        moved = Math.abs(delta);
        track.scrollLeft = startScroll - delta;
      }, { signal: sig });

      function endDrag() {
        if (!dragging) return;
        dragging = false;
        var w = track.clientWidth || 1;
        var scrollDelta = track.scrollLeft - startScroll;  // +ve = moved forward (next)
        var target = startIndex;
        if (Math.abs(scrollDelta) >= w * COMMIT_RATIO) {
          target = startIndex + (scrollDelta > 0 ? 1 : -1);
        }
        target = Math.max(0, Math.min(total - 1, target));
        // Keep snap disabled through the release animation so scroll-snap doesn't
        // fight with the smooth scrollTo and pull us back to startIndex.
        scrollToIndex(target, true);
        setTimeout(function () {
          track.classList.remove('is-grabbing');
        }, 350);
      }
      window.addEventListener('mouseup', endDrag, { signal: sig });
      window.addEventListener('mouseleave', endDrag, { signal: sig });

      // Prevent the anchor's click from navigating to the PDP after a real drag
      track.addEventListener('click', function (e) {
        if (moved > DRAG_THRESHOLD) {
          e.preventDefault();
          e.stopPropagation();
          moved = 0;
        }
      }, { capture: true, signal: sig });

    }

    // Touch swipes use native scroll (no mousedown fires) — prime on first touch.
    if (track) {
      track.addEventListener('touchstart', prime, { passive: true, signal: sig });
    }

    applyVisuals();
    card.dataset.galleryBound = '1';
  }

  // Swipe-hint on page load to cue that product images are swipeable. Only
  // fires ONCE per page load, and only after the target card has been visible
  // in the viewport for a full second (IntersectionObserver + dwell timer).
  // Target selection:
  //   - Touch devices → first card
  //   - Desktop ≥ 1280px (4-col grid) → second card
  //   - Other sizes → no hint
  var galleryHintShown = false;
  function runHintOnTrack(track) {
    var nudge = Math.round(track.clientWidth * 0.18);
    var prevSnap = track.style.scrollSnapType;
    track.style.scrollSnapType = 'none';
    track.scrollTo({ left: nudge, behavior: 'smooth' });
    setTimeout(function () {
      track.scrollTo({ left: 0, behavior: 'smooth' });
      setTimeout(function () {
        track.style.scrollSnapType = prevSnap;
      }, 500);
    }, 600);
  }
  function hintFirstGallerySwipe() {
    if (galleryHintShown) return;
    var cards = Array.from(document.querySelectorAll('product-card.product-card')).filter(function(c) {
      return !c.closest('[data-col-bestsellers]');
    });
    if (!cards.length) return;
    var target;
    if (isTouch()) {
      target = cards[0];
    } else if (window.innerWidth >= 1280) {
      target = cards[1] || cards[0];
    } else {
      return;
    }
    var track = target.querySelector('[data-gallery-track]');
    if (!track) return;
    if (track.scrollWidth <= track.clientWidth + 1) return;

    if (!('IntersectionObserver' in window)) {
      // No IntersectionObserver support — just fire immediately
      galleryHintShown = true;
      runHintOnTrack(track);
      return;
    }

    var dwellTimer = null;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          // Start dwell timer; fire hint after 1s of continuous visibility
          if (dwellTimer || galleryHintShown) return;
          dwellTimer = setTimeout(function () {
            if (galleryHintShown) return;
            galleryHintShown = true;
            runHintOnTrack(track);
            io.disconnect();
          }, 1000);
        } else {
          // Left the viewport — cancel pending hint
          if (dwellTimer) {
            clearTimeout(dwellTimer);
            dwellTimer = null;
          }
        }
      });
    }, { threshold: [0, 0.5, 1] });
    io.observe(target);
  }

  function init() {
    document.querySelectorAll('product-card').forEach(setupGallery);
    // Wire up the swipe hint — it waits for the target card to dwell in
    // the viewport for 1s via IntersectionObserver before firing.
    hintFirstGallerySwipe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Catch ajax-added cards (pagination / filters)
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'PRODUCT-CARD') setupGallery(n);
          else if (n.querySelectorAll) n.querySelectorAll('product-card').forEach(setupGallery);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Expose so card-swatches.js can re-bind after it rebuilds the gallery DOM.
  window.__rebuildProductCardGallery = function (card) {
    if (!card) return;
    card.dataset.galleryBound = '';
    setupGallery(card);
  };
})();

if (!customElements.get('custom-countdown-timer')) {
  class CustomCountdownTimer extends HTMLElement {
    constructor() {
      super();
      var _this = this;
      this.elements = {
        days: this.querySelector('.day .num'),
        hours: this.querySelector('.hour .num'),
        minutes: this.querySelector('.min .num'),
        seconds: this.querySelector('.sec .num'),
      }

      // Parsing the existing MM-DD-YYYY format directly
      let splittedTargetDate = this.dataset.date.split('-');
      let splittedTargetTime = this.dataset.time.split(':');

      this.targetDate = {
        day: parseInt(splittedTargetDate[1]), // Day
        month: parseInt(splittedTargetDate[0]) - 1, // Month, zero-based
        year: parseInt(splittedTargetDate[2]), // Year
        hour: parseInt(splittedTargetTime[0]), // Hour
        minute: parseInt(splittedTargetTime[1]), // Minute
        timezoneOffset: parseInt(this.dataset.timezoneOffset), // Timezone offset
      }

      let userTime = new Date();
      let userTimezoneOffset = userTime.getTimezoneOffset() * 60000;

      this.countDownDate = new Date(this.targetDate.year, this.targetDate.month, this.targetDate.day, this.targetDate.hour, this.targetDate.minute, 0, 0).getTime() - this.targetDate.timezoneOffset - userTimezoneOffset;
      
      this.interval = setInterval(_this.updateTime, 1000, _this);
      this.updateTime(_this);
    }

    updateTime(_this) {
      const now = new Date().getTime();
      const distance = _this.countDownDate - now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      _this.elements.days.innerHTML = _this.addZero(days);
      _this.elements.hours.innerHTML = _this.addZero(hours);
      _this.elements.minutes.innerHTML = _this.addZero(minutes);
      _this.elements.seconds.innerHTML = _this.addZero(seconds);

      if (distance < 0) {
        _this.innerHTML = "EXPIRED";
        clearInterval(_this.interval);
      }
    }

    addZero(x) {
      return (x < 10 && x >= 0) ? "0" + x : x;
    }
  }

  customElements.define('custom-countdown-timer', CustomCountdownTimer);
}

/* =========================================================================
   Product card — measure meta-stack AND reveal natural heights.
   Expose as --meta-height and --slot-height (max of meta and reveal).
   Meta-stack fills the slot via min-height; its white bg covers the reveal
   beneath it at rest. Meta translates up by slot-height on hover.
   ========================================================================= */
(function () {
  // Measured in three passes across every card at once (strip styles, read
  // heights, restore + publish vars) so the page lays out once. Doing all three
  // per card forced two full layouts per card on load.
  function findParts(card) {
    var meta = card.querySelector(':scope > .product-card__info .product-card__meta-stack, :scope > .product-card__info--swatches .product-card__meta-stack');
    if (!meta) return null;
    var reveal = card.querySelector(':scope > .product-card__info .product-card__hover-reveal, :scope > .product-card__info--swatches .product-card__hover-reveal');
    return { card: card, meta: meta, reveal: reveal };
  }

  function measureCards(cards) {
    var jobs = [];
    for (var i = 0; i < cards.length; i++) {
      var job = findParts(cards[i]);
      if (job) jobs.push(job);
    }
    if (!jobs.length) return;

    // Pass 1: strip slot expansion, transforms and clamps so natural heights show.
    jobs.forEach(function (j) {
      j.prevT = j.meta.style.transform;
      j.prevMinH = j.meta.style.minHeight;
      j.meta.style.transform = 'none';
      j.meta.style.minHeight = '0';
      if (j.reveal) {
        j.prevMargin = j.reveal.style.marginTop;
        j.prevRevealMin = j.reveal.style.minHeight;
        j.prevRevealMax = j.reveal.style.maxHeight;
        j.reveal.style.marginTop = '0';
        j.reveal.style.minHeight = '0';
        j.reveal.style.maxHeight = 'none';
      }
    });

    // Pass 2: read. One layout for the whole batch.
    jobs.forEach(function (j) {
      j.mh = Math.ceil(j.meta.getBoundingClientRect().height);
      j.rh = j.reveal ? Math.ceil(j.reveal.getBoundingClientRect().height) : 0;
    });

    // Pass 3: restore and publish. --extra-bottom is how much taller the reveal is
    // than the meta; on hover that padding collapses as the reveal grows, so the
    // card's total height stays constant.
    jobs.forEach(function (j) {
      j.meta.style.transform = j.prevT;
      j.meta.style.minHeight = j.prevMinH;
      if (j.reveal) {
        j.reveal.style.marginTop = j.prevMargin;
        j.reveal.style.minHeight = j.prevRevealMin;
        j.reveal.style.maxHeight = j.prevRevealMax;
      }
      var card = j.card;
      if (j.mh > 0) card.style.setProperty('--meta-height', j.mh + 'px');
      var slot = Math.max(j.mh, j.rh);
      if (slot > 0) card.style.setProperty('--slot-height', slot + 'px');
      card.style.setProperty('--extra-bottom', Math.max(0, j.rh - j.mh) + 'px');
      if (j.rh > 0) card.style.setProperty('--reveal-height', j.rh + 'px');
    });
  }

  function measureAll() {
    measureCards(document.querySelectorAll('product-card'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', measureAll);
  } else {
    measureAll();
  }

  // Re-measure when the width changes. iOS fires resize as the URL bar shows and
  // hides during scroll, which doesn't change any card's text wrapping.
  var t;
  var lastWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    clearTimeout(t);
    t = setTimeout(measureAll, 150);
  });

  // Re-measure after fonts load (title may reflow)
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(measureAll);
  }

  // Newly added cards (pagination, ajax filters) are collected and measured
  // together on the next frame.
  if ('MutationObserver' in window) {
    var queued = [];
    var flushQueued = function () {
      var cards = queued;
      queued = [];
      measureCards(cards);
    };
    var mo = new MutationObserver(function (muts) {
      var hadQueue = queued.length > 0;
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'PRODUCT-CARD') queued.push(n);
          else if (n.querySelectorAll) Array.prototype.push.apply(queued, n.querySelectorAll('product-card'));
        }
      }
      if (!hadQueue && queued.length) requestAnimationFrame(flushQueued);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();


/* =========================================================================
   Product card mobile expand button — tap to toggle the hover-reveal state.
   ========================================================================= */
(function () {
  // "Half-swipe" hint on the swatch track: briefly scroll forward so the user
  // sees the track is horizontally scrollable. Fires at most ONCE per page load.
  var hintShown = false;
  function hintSwipe(card) {
    if (hintShown) return;
    var track = card.querySelector('[data-card-swatches-track]');
    if (!track) return;
    if (track.scrollWidth <= track.clientWidth + 1) return;
    var swatch = track.querySelector('.color-swatch, .thumbnail-swatch');
    if (!swatch) return;
    hintShown = true;
    // Half-swatch nudge — just enough to tease there's more off-screen.
    var nudge = Math.round(swatch.getBoundingClientRect().width * 0.5);
    var start = track.scrollLeft;
    var prevSnap = track.style.scrollSnapType;
    track.style.scrollSnapType = 'none';
    track.scrollTo({ left: start + nudge, behavior: 'smooth' });
    setTimeout(function () {
      track.scrollTo({ left: start, behavior: 'smooth' });
      setTimeout(function () {
        track.style.scrollSnapType = prevSnap;
      }, 500);
    }, 550);
  }

  // When the panel is open on mobile, an image tap should NOT follow the PDP
  // link — instead, close the panel. Runs in capture phase so it intercepts
  // before the anchor's default navigation.
  document.addEventListener('click', function (e) {
    var media = e.target.closest('.product-card__media');
    if (!media) return;
    var card = media.closest('product-card.product-card.is-sticky-open');
    if (!card) return;
    e.preventDefault();
    e.stopPropagation();
    card.classList.remove('is-sticky-open');
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-card-expand]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var card = btn.closest('product-card.product-card');
    if (!card) return;
    // pc--no-reveal cards ignore the button
    if (card.classList.contains('pc--no-reveal')) return;

    var isOpen = card.classList.toggle('is-sticky-open');
    if (isOpen) {
      // Swipe-teaser after the reveal finishes opening (~300ms transition)
      setTimeout(function () { hintSwipe(card); }, 380);

      // Close when user taps anywhere else (but not inside this card)
      setTimeout(function () {
        function onDocTap(ev) {
          if (!card.contains(ev.target)) {
            card.classList.remove('is-sticky-open');
            document.removeEventListener('click', onDocTap, true);
          }
        }
        document.addEventListener('click', onDocTap, true);
      }, 0);
    }
  }, false);
})();

/* =========================================================================
   PDP Gallery Progress Bar — mirrors PLP card gallery approach.
   Re-inits after AJAX section replacement (product-ajax-control.js).
   ========================================================================= */
(function () {
  function initPdpProgress(gallery) {
    if (gallery.dataset.progressBound === '1') return;
    gallery.dataset.progressBound = '1';

    var carousel = gallery.querySelector('.product-gallery__carousel');
    var progressBar = gallery.querySelector('[data-pdp-progress]');
    if (!carousel || !progressBar) return;

    var index = 0;
    var segments = progressBar.querySelectorAll('.pdp-gallery__progress-seg');
    var total = segments.length;

    function applyVisuals() {
      for (var j = 0; j < segments.length; j++) {
        segments[j].classList.toggle('is-active', j === index);
      }
    }

    function onScroll() {
      if (carousel.clientWidth === 0) return;
      var newIndex = Math.round(carousel.scrollLeft / carousel.clientWidth);
      if (newIndex < 0) newIndex = 0;
      if (newIndex >= total) newIndex = total - 1;
      if (newIndex !== index) {
        index = newIndex;
        applyVisuals();
      }
    }

    carousel.addEventListener('scroll', onScroll, { passive: true });

    // Round scrollLeft to an integer pixel on scroll-end to eliminate the
    // 1px subpixel bleed from the previous image's edge.
    var _snapTimer;
    function snapToPixel() {
      var rounded = Math.round(carousel.scrollLeft);
      if (carousel.scrollLeft !== rounded) carousel.scrollLeft = rounded;
    }
    carousel.addEventListener('scrollend', snapToPixel, { passive: true });
    carousel.addEventListener('scroll', function () {
      clearTimeout(_snapTimer);
      _snapTimer = setTimeout(snapToPixel, 120);
    }, { passive: true });

    // Desktop mouse support — lets click-drag scroll the PDP gallery and a
    // short click advance to next/prev (same as a tap would on mobile).
    // Touch devices already handle this natively; we skip the mouse logic there.
    if (!('ontouchstart' in window)) {
      var pdpDragging = false;
      var pdpStartX = 0;
      var pdpStartScroll = 0;
      var pdpMoved = 0;
      var DRAG_THRESHOLD = 5;

      // Disable snap, scroll smoothly to slide i, re-enable snap after animation.
      // Disabling snap during scrollTo prevents the browser from fighting the
      // smooth scroll and causing an instant jump.
      function scrollToSlide(i) {
        i = Math.max(0, Math.min(total - 1, i));
        carousel.style.scrollSnapType = 'none';
        carousel.scrollTo({ left: i * carousel.clientWidth, behavior: 'smooth' });
        setTimeout(function () { carousel.style.scrollSnapType = ''; }, 420);
      }

      carousel.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        pdpDragging = true;
        pdpMoved = 0;
        pdpStartX = e.pageX;
        pdpStartScroll = carousel.scrollLeft;
        // Disable snap so it doesn't fight the live drag
        carousel.style.scrollSnapType = 'none';
        carousel.style.cursor = 'grabbing';
      });

      window.addEventListener('mousemove', function (e) {
        if (!pdpDragging) return;
        var delta = e.pageX - pdpStartX;
        pdpMoved = Math.abs(delta);
        carousel.scrollLeft = pdpStartScroll - delta;
      });

      function pdpEndDrag(e) {
        if (!pdpDragging) return;
        pdpDragging = false;
        carousel.style.cursor = '';

        if (pdpMoved <= DRAG_THRESHOLD) {
          // Short click — advance based on which half was clicked
          var rect = carousel.getBoundingClientRect();
          var clickX = (e && e.clientX != null) ? e.clientX : pdpStartX;
          scrollToSlide(index + (clickX >= rect.left + rect.width / 2 ? 1 : -1));
        } else {
          // Drag — glide to nearest slide
          var nearest = Math.round(carousel.scrollLeft / (carousel.clientWidth || 1));
          scrollToSlide(nearest);
        }
      }
      window.addEventListener('mouseup', pdpEndDrag);
      window.addEventListener('mouseleave', function () {
        if (!pdpDragging) return;
        pdpDragging = false;
        carousel.style.cursor = '';
        var nearest = Math.round(carousel.scrollLeft / (carousel.clientWidth || 1));
        scrollToSlide(nearest);
      });

      // Prevent anchor/image native drag from hijacking mouse events
      carousel.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    applyVisuals();
  }

  function initAll() {
    document.querySelectorAll('product-gallery').forEach(initPdpProgress);
  }

  initAll();

  // Re-init after AJAX section replacement (color swap)
  document.addEventListener('shopify:section:load', function () {
    setTimeout(initAll, 50);
  });
})();

/* =========================================================================
   Core / Seasonal color group tabs — PDP
   Renders both panels server-side; JS only toggles visibility.
   ========================================================================= */
(function () {
  function initColorGroupTabs(wrap) {
    var tabs = wrap.querySelectorAll('[data-color-tab]');
    var panels = wrap.querySelectorAll('[data-color-panel]');
    if (!tabs.length || !panels.length) return;

    // Activate first panel on init
    panels[0].classList.add('is-active');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-color-tab');
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-color-panel') === target);
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.product-color-groups--tabs').forEach(initColorGroupTabs);
  }

  initAll();
  document.addEventListener('shopify:section:load', function () { setTimeout(initAll, 50); });
})();

/* =========================================================================
   PDP Model Info Badge — wait for sibling image to load before revealing.
   ========================================================================= */
(function () {
  function revealBadge(badge) {
    var wrap = badge.closest('.product-gallery__media');
    if (!wrap) return;
    var img = wrap.querySelector('img');
    if (!img || (img.complete && img.naturalWidth > 0)) {
      badge.style.opacity = '1';
      return;
    }
    img.addEventListener('load', function () { badge.style.opacity = '1'; }, { once: true });
    img.addEventListener('error', function () { badge.style.opacity = '1'; }, { once: true });
  }

  document.querySelectorAll('.product-gallery__model-info').forEach(revealBadge);

  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.classList && n.classList.contains('product-gallery__model-info')) {
            revealBadge(n);
          } else if (n.querySelectorAll) {
            n.querySelectorAll('.product-gallery__model-info').forEach(revealBadge);
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
